import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/cashwheel/pddv2_top_frame.png'
import _imports_1 from '@/assets/cashwheel/pddv2_top_btn.png'
import _imports_2 from '@/assets/cashwheel/pddv2_share_item.png'
import _imports_3 from '@/assets/cashwheel/pddv2_middle_bg.png'
import _imports_4 from '@/assets/cashwheel/pddv2_middle_left.png'
import _imports_5 from '@/assets/cashwheel/pddv2_middle_right.png'


const _hoisted_1 = { class: "cashWheel" }
const _hoisted_2 = { class: "wheel_container" }
const _hoisted_3 = { class: "top_frame" }
const _hoisted_4 = { class: "bar" }
const _hoisted_5 = { class: "timer" }
const _hoisted_6 = { class: "report" }
const _hoisted_7 = { class: "report_table" }
const _hoisted_8 = {
  key: 0,
  src: _imports_4,
  alt: "",
  class: "headText"
}
const _hoisted_9 = {
  key: 0,
  src: _imports_5,
  alt: "",
  style: {"margin":"5px 0 0px -23px"}
}
const _hoisted_10 = { class: "bottom_text" }

import { formatCurrency } from '@/utils/commonFunction';
import { computed, onMounted, onUnmounted, ref, watch } from 'vue'
import CashWheel from './components/cashWheel.vue';
import ReportData from './components/reportData.vue';
import PaymentPopup from './components/paymentPopup.vue';
import WinPopup from './components/winPopup.vue';

export default /*@__PURE__*/_defineComponent({
  __name: 'cashWheelView',
  setup(__props) {

// import CustomHeader from '@/components/common/customHeader.vue';
const resData = ref({
    can_join: 1,

    user_pdd_info: {
        activity_intro: [
            "1.Você pode começar a sacar dinheiro quando o valor acumulado atingir 100BRL\n",
            "2.Convidar amigos para se registrarem em 688v.com irá ajudá-lo a sacar dinheiro rapidamente.\n",
            "3.Cada usuário receberá uma rodada grátis por dia.\n",
            "4.A atividade de cada usuário é válida por 3 dias e pode participar da atividade várias vezes.\n",
            "5.Se você receber um bônus extra, poderá jogar de graça e ganhar mais dinheiro real.\n",
            "6.Se nenhum saque for feito dentro de 3 dias, os fundos serão perdidos.\n"
        ],
        current_progress: 9452,
        current_target: 10000,
        days: 3,
        draw_count: 1,
        end_time: 1748259494,
        receive_rewards: 0,
        share_link: "https://688v.team/#/cashwheel?a=styk1ngs",
        start_time: 1748000294
    }
});

const assistList = ref({
    assists: [],
    rewards: [
        {
            coin: 10000,
            content: "Acabou de sacar",
            phone: "5569966036826"
        },
        {
            coin: 10000,
            content: "Acabou de sacar",
            phone: "5529955672359"
        },
        {
            coin: 10000,
            content: "Acabou de sacar",
            phone: "5537992670787"
        },
        {
            coin: 10000,
            content: "Acabou de sacar",
            phone: "5534939022762"
        },
        {
            coin: 10000,
            content: "Acabou de sacar",
            phone: "5559935934836"
        },
        {
            coin: 10000,
            content: "Acabou de sacar",
            phone: "5548966762018"
        },
        {
            coin: 10000,
            content: "Acabou de sacar",
            phone: "5529929388973"
        },
        {
            coin: 10000,
            content: "Acabou de sacar",
            phone: "5527998799919"
        },
        {
            coin: 10000,
            content: "Acabou de sacar",
            phone: "5514912448710"
        },
        {
            coin: 10000,
            content: "Acabou de sacar",
            phone: "5575967865248"
        },

        {
            coin: 10000,
            content: "Acabou de sacar",
            phone: "5543972354561"
        },
        {
            coin: 10000,
            content: "Acabou de sacar",
            phone: "5548954560432"
        },
        {
            coin: 10000,
            content: "Acabou de sacar",
            phone: "5517935598177"
        },
        {
            coin: 10000,
            content: "Acabou de sacar",
            phone: "5569929029201"
        }
    ]
})
const selectedReportType = ref(0)
const payementRef = ref()
const animatedValue = ref(0)
const endTime = new Date('2025-05-30T18:00:00Z').getTime() // example end time (ms)
const winPopupRef = ref()
const formattedTime = ref('')
const progressPercentage = computed(() => resData.value.user_pdd_info.current_progress / 100);


function formatDuration(ms: number) {
    if (ms <= 0) return '0d 00:00:00'

    const totalSeconds = Math.floor(ms / 1000)
    const days = Math.floor(totalSeconds / (3600 * 24))
    const hours = Math.floor((totalSeconds % (3600 * 24)) / 3600)
    const minutes = Math.floor((totalSeconds % 3600) / 60)
    const seconds = totalSeconds % 60

    return `${days}d ${hours.toString().padStart(2, '0')}:${minutes
        .toString()
        .padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`
}

let timerInterval: number

function updateTimer() {
    const now = Date.now()
    const diff = endTime - now
    formattedTime.value = formatDuration(diff)
    if (diff <= 0 && timerInterval) {
        clearInterval(timerInterval)
    }
}

const showWinDetails = () => {
    winPopupRef.value.open((resData.value))
}
onMounted(() => {
    updateTimer()
    timerInterval = window.setInterval(updateTimer, 1000)
})

onUnmounted(() => {
    clearInterval(timerInterval)
})
const selectReportType = (value: number) => {
    selectedReportType.value = value
}
const showPayment = () => {
    payementRef.value.open(resData.value)
}

const animateValue = (start: number, end: number, duration: number) => {
    const startTime = performance.now()

    const step = (currentTime: number) => {
        const progress = Math.min((currentTime - startTime) / duration, 1)
        animatedValue.value = start + (end - start) * progress

        if (progress < 1) {
            requestAnimationFrame(step)
        } else {
            animatedValue.value = end
        }
    }

    requestAnimationFrame(step)
}

watch(
    () => resData.value.user_pdd_info.current_progress,
    (newVal) => {
        const target = newVal / 100
        animateValue(0, target, 800) // 800ms animation
    },
    { immediate: true }
)

return (_ctx: any,_cache: any) => {
  const _component_van_col = _resolveComponent("van-col")!
  const _component_van_row = _resolveComponent("van-row")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _cache[3] || (_cache[3] = _createElementVNode("img", {
            src: _imports_0,
            alt: ""
          }, null, -1)),
          _createVNode(_component_van_row, { class: "top_middle" }, {
            default: _withCtx(() => [
              _createVNode(_component_van_col, {
                span: "10",
                offset: "7",
                class: "cash"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(formatCurrency)(animatedValue.value)), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_van_col, {
                span: "7",
                style: _normalizeStyle({ opacity: resData.value.user_pdd_info.current_progress == 0 ? '0.45' : '' }),
                class: "top_btn"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("img", {
                    src: _imports_1,
                    alt: "",
                    onClick: showPayment
                  })
                ]),
                _: 1
              }, 8, ["style"]),
              _createVNode(_component_van_col, { span: "24" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", {
                      class: "progress",
                      style: _normalizeStyle({ width: resData.value.user_pdd_info.current_progress / 100 + '%' })
                    }, null, 4),
                    _createElementVNode("div", {
                      class: "progress-end-dot",
                      style: _normalizeStyle({ left: `calc(${progressPercentage.value}% - 6px)` })
                    }, null, 4)
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_van_col, {
                span: "24",
                class: "top_text"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('cashWheel.neccessary')) + " ", 1),
                  _cache[2] || (_cache[2] = _createElementVNode("span", null, _toDisplayString(5.38), -1)),
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('cashWheel.makeWithdrawal')), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _createVNode(CashWheel, { onShowWinPopup: showWinDetails })
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("span", null, [
          _createTextVNode(_toDisplayString(_ctx.$t('cashWheel.expireIn')) + " ", 1),
          _createElementVNode("span", null, _toDisplayString(formattedTime.value), 1)
        ])
      ]),
      _cache[7] || (_cache[7] = _createElementVNode("div", { class: "share_item" }, [
        _createElementVNode("img", {
          src: _imports_2,
          alt: ""
        })
      ], -1)),
      _createElementVNode("div", _hoisted_6, [
        _cache[4] || (_cache[4] = _createElementVNode("img", {
          src: _imports_3,
          alt: ""
        }, null, -1)),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_van_row, { class: "head_table" }, {
            default: _withCtx(() => [
              _createVNode(_component_van_col, { span: "12" }, {
                default: _withCtx(() => [
                  (selectedReportType.value == 0)
                    ? (_openBlock(), _createElementBlock("img", _hoisted_8))
                    : (_openBlock(), _createElementBlock("div", {
                        key: 1,
                        class: "empty_container1",
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (selectReportType(0)))
                      }))
                ]),
                _: 1
              }),
              _createVNode(_component_van_col, { span: "12" }, {
                default: _withCtx(() => [
                  (selectedReportType.value == 1)
                    ? (_openBlock(), _createElementBlock("img", _hoisted_9))
                    : (_openBlock(), _createElementBlock("div", {
                        key: 1,
                        class: "empty_container2",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (selectReportType(1)))
                      }))
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(ReportData, {
            dataList: assistList.value.rewards
          }, null, 8, ["dataList"])
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createVNode(_component_van_row, { style: {"padding-bottom":"10px"} }, {
          default: _withCtx(() => [
            _createVNode(_component_van_col, {
              span: "6",
              class: ""
            }, {
              default: _withCtx(() => _cache[5] || (_cache[5] = [
                _createElementVNode("div", { class: "line1" }, null, -1)
              ])),
              _: 1
            }),
            _createVNode(_component_van_col, {
              span: "12",
              class: "title"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", null, _toDisplayString(_ctx.$t("common.activityTitle")), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_van_col, {
              span: "6",
              class: ""
            }, {
              default: _withCtx(() => _cache[6] || (_cache[6] = [
                _createElementVNode("div", { class: "line2" }, null, -1)
              ])),
              _: 1
            })
          ]),
          _: 1
        }),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(resData.value.user_pdd_info.activity_intro, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "line_text",
            key: index
          }, _toDisplayString(item), 1))
        }), 128))
      ])
    ]),
    _createVNode(PaymentPopup, {
      ref_key: "payementRef",
      ref: payementRef
    }, null, 512),
    _createVNode(WinPopup, {
      ref_key: "winPopupRef",
      ref: winPopupRef
    }, null, 512)
  ], 64))
}
}

})